export const getters = {
    ACCEPTED_TERMS: 'auth/ACCEPTED_TERMS',
    ALLOW_PERSISTENT_SESSIONS: 'auth/ALLOW_PERSISTENT_SESSIONS',
    APP_UPDATE_REQUIRED: 'app/APP_UPDATE_REQUIRED',
    AUTH_ERROR: 'auth/AUTH_ERROR',
    CURRENT_TERMS_ID: 'auth/CURRENT_TERMS_ID',
    READY: 'auth/READY',
    THEME: 'auth/THEME',
    USER_GROUP_ROLE_BY_ID: 'auth/USER_GROUP_ROLE_BY_ID',
    USER_GROUP_IS_ADMIN: 'auth/USER_GROUP_IS_ADMIN',
    USER_GROUPS_IS_ADMIN: 'auth/USER_GROUPS_IS_ADMIN',
    USER_ID: 'auth/USER_ID',
    USER_PERMISSION: 'auth/USER_PERMISSION',
    USER_PREFERENCES: 'auth/USER_PREFERENCES',
    USER_DASHBOARD_PERMISSIONS: 'auth/USER_DASHBOARD_PERMISSIONS',
    USER_IS_DASHBOARD_ADMIN: 'auth/USER_IS_DASHBOARD_ADMIN',
};

export const actions = {
	APP_DRAWER_CLOSE: 'app/APP_DRAWER_CLOSE',
	APP_DRAWER_OPEN: 'app/APP_DRAWER_OPEN',
    APP_DRAWER_TOGGLE: 'app/APP_DRAWER_TOGGLE',
    APP_LATEST_VERSION_DATE_SET: 'app/APP_LATEST_VERSION_DATE_SET',
    LAST_LOGIN_UPDATE: 'app/LAST_LOGIN_UPDATE',
    LOGOUT: 'auth/LOGOUT',
    THEME_LOAD: 'auth/THEME_LOAD',
    THEME_SET: 'auth/THEME_SET',
    USER_GROUP_ROLES_LOAD: 'auth/USER_GROUP_ROLES_LOAD',
    USER_PREFERENCES_LOAD: 'auth/USER_PREFERENCES_LOAD',
    USER_PREFERENCES_UPDATE: 'auth/USER_PREFERENCES_UPDATE',
    USER_DASHBOARD_PERMISSIONS_LOAD: 'auth/USER_DASHBOARD_PERMISSIONS_LOAD',
};

export const mutations = {
	APP_DRAWER_CLOSE: 'app/APP_DRAWER_CLOSE',
    APP_DRAWER_OPEN: 'app/APP_DRAWER_OPEN',
    APP_LATEST_VERSION_DATE_SET: 'app/APP_LATEST_VERSION_DATE_SET',
    AUTH_ERROR_SET: 'auth/AUTH_ERROR_SET',
    READY_SET: 'auth/READY_SET',
    THEME_SET: 'auth/THEME_SET',
    USER_PREFERENCES_CLEAR: 'auth/USER_PREFERENCES_CLEAR',
    USER_PREFERENCES_SET: 'auth/USER_PREFERENCES_SET',
    USER_GROUP_ROLES_CLEAR: 'auth/USER_GROUP_ROLES_CLEAR',
    USER_GROUP_ROLES_SET: 'auth/USER_GROUP_ROLES_SET',
    USER_DASHBOARD_PERMISSIONS_SET: 'auth/USER_DASHBOARD_PERMISSIONS_SET',
};


export const types = {
	getters,
	actions, 
	mutations
};

export default types;
